import React from 'react';
import { connect } from 'react-redux';
import { hideNotification } from 'swag-client-common/redux/notification/notification.actions';
import Notification from '../../components/ui/notification';
class NotificationManagerContainer extends React.Component {
  render() {
    const {
      notification: {
        text,
        isShown,
        dataAttr
      },
      onClose
    } = this.props;
    return /*#__PURE__*/React.createElement(Notification, {
      isShown: isShown,
      text: text,
      onClose: onClose,
      dataAttr: dataAttr
    });
  }
}
const mapStateToProps = state => ({
  notification: state.notification
});
const mapDispatchToProps = dispatch => ({
  onClose: () => {
    dispatch(hideNotification());
  }
});
export default connect(mapStateToProps, mapDispatchToProps)(NotificationManagerContainer);